import React from 'react'
import { Mail, MapPin } from 'lucide-react'
import { useTranslation } from 'react-i18next'

const Footer = () => {
  const { t } = useTranslation()
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-dark-900 text-white">
      <div className="container-custom py-16 !pl-0">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">

          {/* Logo + Redes Sociais */}
          <div className="space-y-6 lg:col-span-3">
            <div>
              <img
                src={`${import.meta.env.BASE_URL}images/LogoFinal.png`}
                alt="AGS Global Logistics"
                className="h-36 w-auto object-contain"
              />
            </div>

          </div>

          {/* Unidades */}
          <div className="lg:col-span-9 grid grid-cols-1 sm:grid-cols-3 gap-8">

            {/* Matriz */}
            <div>
              <h3 className="font-heading font-bold text-base mb-1 text-white">São Paulo</h3>
              <span className="text-xs font-semibold tracking-widest uppercase text-primary-400 mb-3 block">{t('footer.matriz')}</span>
              <ul className="space-y-2">
                <li className="flex items-start gap-2 text-dark-300 text-sm">
                  <MapPin size={15} className="text-primary-400 mt-0.5 flex-shrink-0" />
                  <span>Estr. dos Alpes, 1670 - Res. Morada dos Lagos<br />Barueri - SP, 06423-080</span>
                </li>
                <li className="flex items-center gap-2 text-dark-300 text-sm">
                  <Mail size={15} className="text-primary-400 flex-shrink-0" />
                  <span>contato@agsgloballogistics.com</span>
                </li>
              </ul>
            </div>

            {/* Filial */}
            <div>
              <h3 className="font-heading font-bold text-base mb-1 text-white">Duque de Caxias - RJ</h3>
              <span className="text-xs font-semibold tracking-widest uppercase text-primary-400 mb-3 block">{t('footer.filial')}</span>
              <ul className="space-y-2">
                <li className="flex items-start gap-2 text-dark-300 text-sm">
                  <MapPin size={15} className="text-primary-400 mt-0.5 flex-shrink-0" />
                  <span>Avenida SN nº 1 - Duque de Caxias - RJ<br />CEP: 25085-378<br />Quadra A, Lote 345, Módulo 06</span>
                </li>
                <li className="flex items-center gap-2 text-dark-300 text-sm">
                  <Mail size={15} className="text-primary-400 flex-shrink-0" />
                  <span>contato@agsgloballogistics.com</span>
                </li>
              </ul>
            </div>

            {/* Internacional */}
            <div>
              <h3 className="font-heading font-bold text-base mb-1 text-white">Miami</h3>
              <span className="text-xs font-semibold tracking-widest uppercase text-primary-400 mb-3 block">{t('footer.internacional')}</span>
              <ul className="space-y-2">
                <li className="flex items-start gap-2 text-dark-300 text-sm">
                  <MapPin size={15} className="text-primary-400 mt-0.5 flex-shrink-0" />
                  <span>10243 NW 62nd St, Doral, FL 33178</span>
                </li>
                <li className="flex items-center gap-2 text-dark-300 text-sm">
                  <Mail size={15} className="text-primary-400 flex-shrink-0" />
                  <span>contato@agsgloballogistics.com</span>
                </li>
              </ul>
            </div>

          </div>
        </div>
      </div>

      <div className="border-t border-dark-800">
        <div className="container-custom py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-dark-400 text-sm">
              {t('footer.copyright', { year: currentYear })}
            </p>
            <div className="flex space-x-6 text-sm">
              <a href="#" className="text-dark-400 hover:text-primary-400 transition-colors">{t('footer.privacy')}</a>
              <a href="#" className="text-dark-400 hover:text-primary-400 transition-colors">{t('footer.terms')}</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
